import {getUrlParam} from "./common";

function redirectFun(name) {
  let reUrl = window.location.origin+"/new/";
  if (name == 'index') {
    window.location.href = reUrl;
  } else if (name == 'general') {
    window.location.href = reUrl + 'general/' + getUrlParam('id');
  } else if (name == 'atlas') {
    window.location.href = reUrl + 'atlas/' + getUrlParam('id');
  } else if (name == 'comment') {
    window.location.href = reUrl + 'comment/' + getUrlParam('id');
  } else if (name == 'hotSearch') {
    window.location.href = reUrl + 'hotSearch/' + getUrlParam('id');
  } else if (name == 'info') {
    window.location.href = reUrl + 'info/' + getUrlParam('id');
  } else if (name == 'information') {
    window.location.href = reUrl + 'information/' + getUrlParam('id') + '/' + getUrlParam('name') + '/' + getUrlParam('newsId');
  } else if (name == 'live') {
    window.location.href = reUrl + 'living/share/' + getUrlParam('id');
  } else if (name == 'thematic') {
    window.location.href = reUrl + 'thematic/' + getUrlParam('id');
  } else if (name == 'thinkTank') {
    window.location.href = reUrl + 'thinkTank/' + getUrlParam('id');
  } else if (name == 'video') {
    if (getUrlParam('liveId')) {
      window.location.href = reUrl + 'videos/' + getUrlParam('id') + '/' + getUrlParam('liveId');
    } else {
      window.location.href = reUrl + 'videos/' + getUrlParam('id');
    }
  } else if (name == 'videoXx') {
    if (getUrlParam('liveId')) {
      window.location.href = reUrl + 'videosXx/' + getUrlParam('id') + '/' + getUrlParam('liveId');
    } else {
      window.location.href = reUrl + 'videosXx/' + getUrlParam('id');
    }
  } else if (name == 'ydIndex') {
    window.location.href = reUrl + 'ydIndex/' + getUrlParam('id');
  }
}

export {redirectFun}



// WEBPACK FOOTER //
// ./src/common/js/redirectUrl.js